// extracted by mini-css-extract-plugin
export default {"text":"PageNotFound_text__I0-c3","error-code":"PageNotFound_error-code__+5aVa"};